import Modal from './Modal';
import { InformationCircleIcon, ExclamationTriangleIcon, XCircleIcon } from '@heroicons/react/24/outline';

interface AlertDialogProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string;
    confirmText?: string;
    variant?: 'info' | 'warning' | 'error' | 'success';
}

export default function AlertDialog({
    isOpen,
    onClose,
    title,
    message,
    confirmText = 'OK',
    variant = 'info',
}: AlertDialogProps) {
    const variantConfig = {
        info: {
            icon: InformationCircleIcon,
            color: 'text-blue-600',
            button: 'bg-blue-600 hover:bg-blue-700 text-white',
        },
        warning: {
            icon: ExclamationTriangleIcon,
            color: 'text-yellow-600',
            button: 'bg-yellow-600 hover:bg-yellow-700 text-white',
        },
        error: {
            icon: XCircleIcon,
            color: 'text-red-600',
            button: 'bg-red-600 hover:bg-red-700 text-white',
        },
        success: {
            icon: InformationCircleIcon, // Using Info icon for success for now, or import CheckCircle if available
            color: 'text-green-600',
            button: 'bg-green-600 hover:bg-green-700 text-white',
        }
    };

    const config = variantConfig[variant];
    const Icon = config.icon;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size="sm"
            footer={
                <div className="flex justify-end">
                    <button
                        type="button"
                        onClick={onClose}
                        className={`${config.button} px-6 py-2 rounded-lg font-medium transition-colors`}
                    >
                        {confirmText}
                    </button>
                </div>
            }
        >
            <div className="flex items-start gap-4">
                <div className={`flex-shrink-0 ${config.color}`}>
                    <Icon className="w-8 h-8" />
                </div>
                <div className="flex-1">
                    <p className="text-gray-700 leading-relaxed">{message}</p>
                </div>
            </div>
        </Modal>
    );
}
